<template>
  <div class="align-end">
    <v-btn
      v-if="socketMessage.length > 4"
      class="button-border view-all-button"
      tile
      :text="viewAll"
      block
      @click="$emit('viewAll', $event)"
    >
      <span class="subtitle-2">
        {{ viewAll ? $t("Hide") : $t("ViewAll") }}
      </span>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "ViewAllButton",

  props: {
    socketMessage: {
      type: Array
    },
    viewAll: {
      type: Boolean
    }
  }
};
</script>

<style scoped>
.view-all-button {
  background-color: transparent !important;
  color: #231e46 !important;
  font-family: Lato !important;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 700;
  line-height: 16px !important;
  text-transform: uppercase;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Management/Notifications/_Atoms/ViewAllButton.vue